import http from './http';
import { listResource } from './listResource';

// Competitions
// Listar competiciones
export async function listCompetitions(options = {}) {
  return listResource('/competitions', options);
}

export async function listCompetitionsForDownload(options = {}) {
  return listResource('/competitions/for-download', options);
}

// Obtener una competición por su ID
export async function getCompetitionById(id) {
  const res = await http.get(`/competitions/${id}`);
  return res.data?.data ?? res.data;
}

// Crear una nueva competición
export async function createCompetition(payload) {
  const res = await http.post('/competitions', payload);
  return res.data?.data ?? res.data;
}

// Actualizar una competición existente
export async function updateCompetition(id, payload) {
  const res = await http.put(`/competitions/${id}`, payload);
  return res.data?.data ?? res.data;
}

// Eliminar competición
export const deleteCompetition = (id) => http.delete(`/competitions/${id}`);

// Subir archivo de imagen para competición
export async function uploadCompetitionMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/competition', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

// Verificar si un título ya existe
export async function checkCompetitionTitleExists(title, excludeId = null) {
  try {
    const { items } = await listCompetitions({ search: title });
    const exists = items?.some(
      (competition) =>
        competition.description?.toLowerCase() === title?.toLowerCase() &&
        competition.id !== excludeId
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar título:', error);
    return false;
  }
}

// Publicar competición
export async function publishCompetition(id) {
  const res = await http.post(`/competitions/${id}/publish`);
  return res.data?.data ?? res.data;
}

// Clonar competición
export const cloneCompetition = (id) => http.post(`/competitions/${id}/clone`);

// Cancelar competición
export async function cancelCompetition(id, payload) {
  const res = await http.patch(`/competitions/${id}/cancel`, payload);
  return res.data?.data ?? res.data;
}

// Competition Days
// Listar días de una competición
export async function getCompetitionDays(CompetitionId) {
  const res = await http.get(`/competitions/${CompetitionId}/days`);
  return res.data?.data ?? res.data;
}

// Crear un día
export async function createCompetitionDay(CompetitionId, payload) {
  const res = await http.post(`/competitions/${CompetitionId}/days`, payload);
  return res.data?.data ?? res.data;
}

// Actualizar un día
export async function updateCompetitionDay(CompetitionId, dayId, payload) {
  const res = await http.put(`/competitions/${CompetitionId}/days/${dayId}`, payload);
  return res.data?.data ?? res.data;
}

// Eliminar un día
export async function deleteCompetitionDay(CompetitionId, dayId) {
  const res = await http.delete(`/competitions/${CompetitionId}/days/${dayId}`);
  return res.data?.data ?? res.data;
}

// Actualizar warm-up del día
export async function updateCompetitionDayWarmUp(CompetitionId, dayId, warmUpId) {
  const res = await http.put(`/competitions/${CompetitionId}/days/${dayId}/warm-up`, {
    warm_up_id: warmUpId,
  });
  return res.data?.data ?? res.data;
}

// Actualizar estiramiento del día
export async function updateCompetitionDayStretch(CompetitionId, dayId, stretchId) {
  const res = await http.put(`/competitions/${CompetitionId}/days/${dayId}/stretch`, {
    stretch_id: stretchId,
  });
  return res.data?.data ?? res.data;
}

// Competition Day Exercises
export async function listCompetitionDayExercises(CompetitionId, dayId) {
  const res = await http.get(`/competitions/${CompetitionId}/days/${dayId}/exercises`);
  return res.data?.data ?? res.data?.items ?? res.data ?? [];
}

export async function createCompetitionDayExercise(CompetitionId, dayId, payload) {
  const res = await http.post(`/competitions/${CompetitionId}/days/${dayId}/exercises`, payload);
  return res.data?.data ?? res.data;
}

export async function updateCompetitionDayExercise(CompetitionId, dayId, CompetitionDayExerciseId, payload) {
  const res = await http.put(
    `/competitions/${CompetitionId}/days/${dayId}/exercises/${CompetitionDayExerciseId}`,
    payload
  );
  return res.data?.data ?? res.data;
}

export async function deleteCompetitionDayExercise(CompetitionId, dayId, CompetitionDayExerciseId) {
  const res = await http.delete(
    `/competitions/${CompetitionId}/days/${dayId}/exercises/${CompetitionDayExerciseId}`
  );
  return res.data?.data ?? res.data;
}

export async function listWinners(options = {}) {
  return listResource('/competitions/winners', options);
}

export async function listPreliminaries(options = {}) {
  return listResource('/competitions/preliminaries', options);
}

export async function listPreliminaryVideos(id, options = {}) {
  return listResource(`/competitions/preliminary/${id}`, options);
}

export async function sendCompetitionToJudges(id, payload = {}) {
  const res = await http.patch(`/competitions/${id}/sendToJudges`, payload);
  return res.data?.data ?? res.data;
}

export async function listRanking(options = {}) {
  return listResource('/ranking', options);
}

export async function getClientRankingVideos(id,options = {}) {
  return listResource('/ranking/client/'+id, options);
}

export async function listEvaluationHistory(options = {}) {
  return listResource('/ranking', options);
}

export async function getCompetitionRankingVideos(id, top,options = {}) {
  return listResource(`/competitions/${id}/top/${top}`, options);
}

export async function sendClaimForm(payload) {
  const res = await http.post('/prize-claims/notifications', payload);
  return res.data?.data ?? res.data;
}

export async function getPrizeClaim(videoId) {
  const res = await http.get(`/prize-claims/video/${videoId}`);
  return res.data?.data ?? res.data;
}

export async function updatePrizeClaimStatus(id, payload) {
  const res = await http.patch(`/prize-claims/${id}/status`, payload);
  return res.data?.data ?? res.data;
}

export async function createPrizeClaim(payload) {
  const res = await http.post('/prize-claims', payload);
  return res.data?.data ?? res.data;
}

export async function uploadPaymentReceipt(file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await http.post('/files/upload/receipt', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.data ?? res.data;
}

